// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3vlvT","title":"styles_title__ZAQ-N"};